module.exports = __webpack_public_path__ + "static/media/Gastly_gaussian2.d7a383bd.png";